<svg
  xmlns="http://www.w3.org/2000/svg"
  class={$$restProps.class}
  viewBox="0 0 24 24"
>
  <path
    d="M23.5 13.0986328l-.5-.75V11c0-1.1030273-.8969727-2-2-2h-4.3818359c-.2519531 0-.3813477-.1660156-.425293-.2373047-.0444336-.0712891-.1347656-.2612305-.0219727-.4863281l1.6054688-3.2109375C17.9228516 4.7729492 18 4.4453125 18 4.1181641 18 2.9501953 17.0498047 2 15.8818359 2H15.5c-.1386719 0-.2709961.0576172-.3657227.1586914L9.7480469 7.9296875C8.6210938 9.1376953 8 10.7128906 8 12.3647461V17c0 2.7568359 2.2431641 5 5 5h5.4296875c.8378906 0 1.6152344-.4160156 2.0800781-1.1132813L23.5 16.4013672C23.8271484 15.9116211 24 15.340332 24 14.75S23.8271484 13.5883789 23.5 13.0986328zM5 9H2c-1.1030273 0-2 .8969727-2 2v9c0 1.1030273.8969727 2 2 2h3c1.1030273 0 2-.8969727 2-2v-9C7 9.8969727 6.1030273 9 5 9z"
  />
</svg>
